import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { TypographyNavLink } from "../../../Typographies/TypographyNavLink";
import { MyMealsMenu } from "../../MyMealsMenu/MainComponents/MyMealsMenu";
import { AccountRoutesType } from "../../navigationUtils";
import { NavBarAccountMenu } from "../NavBarAccountMenu/NavBarAccountMenu";
import { useNavLinks } from "../../hooks/useNavLinks";
export const NavBarAccountPagesLinks = () => {
    const L = useNavLinks();
    return (_jsx(_Fragment, { children: L.navBarLinks.map((nav) => {
            if (nav.to === AccountRoutesType.MY_MEALS) {
                // Render MyMealsMenu.
                return _jsx(MyMealsMenu, { isNavDrawer: false, displayText: nav.displayText }, nav.displayText);
            }
            else if (nav.to === AccountRoutesType.ACCOUNT_MENU) {
                // Render the NavBarAccountMenu.
                return (_jsx(NavBarAccountMenu, { menuItems: nav.menuItems, hideAddresses: L.hideAddresses, hideBillingInformation: L.hideBillingInformation, displayText: nav.displayText }, nav.displayText));
            }
            else if (nav.menuItems === null) {
                // Render standalone links
                return (nav.to && (_jsx(TypographyNavLink, Object.assign({ to: nav.to }, { children: nav.displayText }), nav.to)));
            }
            else {
                return null; // Default case for unhandled or invalid nav items.
            }
        }) }));
};
